import React, { useEffect, useState } from 'react'
import { Card, Input } from 'antd'
import { EntityKind } from '../../routes'
import RecentChips from './RecentChips'

interface FindBoxProps {
    kind: EntityKind
    title: string
    placeholder: string
    // The id currently open (from the URL)
    value?: string
    loading?: boolean
    onFind: (value: string) => void
}

const FindBox: React.FC<FindBoxProps> = ({ kind, title, placeholder, value = '', loading, onFind }) => {
    const [text, setText] = useState(value)

    useEffect(() => {
        setText(value)
    }, [value])

    return (
        <Card title={title} className="find-box">
            {/* Clearing the field calls onFind('') which empties the page */}
            <Input.Search
                size="large"
                placeholder={placeholder}
                value={text}
                onChange={(e) => setText(e.target.value)}
                onSearch={onFind}
                enterButton="Find"
                allowClear
                loading={loading}
                aria-label={title}
            />
            <RecentChips kinds={[kind]} exclude={value} />
        </Card>
    )
}

export default FindBox
